define.alias("ember-truth-helpers/helpers/not", "media/helpers/not");